// src/components/Math.jsx
import { InlineMath, BlockMath } from 'react-katex';

export const IM = ({ children }) => <InlineMath math={children} />;
export const BM = ({ children }) => <BlockMath math={children} />;


const settings = {
  strict: 'ignore',
  macros: { '\\euro': '\\text{€}' }
};
